<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import Complex from './functions/complexClass';
	import Fraction from './functions/fractionClass';
	//import brackets from './functions/brackets';
	//import fractionBuilder from './functions/fractionBuilder';

	export let uqn: number;

	let t: number;
	let ans: string, bc: string;
	$: t = Number(uqn.toString()[0]);
	$: ans = uqnToQn(uqn,t);
	function uqnToQn(u:number,t:number):string{
		if (t==1 || t==2){ // cubic
			return type12Generator(u);
		} else if (t<5){ // quartic
			return type34Generator(u);
		} else if (t==5 || t==6){ //  
			return type5Generator(u);
		}
	}

	function type12Generator(u:number):string{
		let [t, x, y, r, sign] = uqnSplit(u);
		let a = 1;
		if (sign>3){
			a = 2; r = r*2-1;
		}
		const xrSign = sign%4;
		if (xrSign%2==1){
			r *= -1;
		}
		if (xrSign>1){
			x *= -1;
		}
		const root1 = new Complex(x,y);
		const root2 = new Complex(x,-y);
		const thirdRoot = new Fraction(r,a);
		let roots = "z=" + root1.toString() + ", z=" + root2.toString() + "\\textrm{ or } z=" + thirdRoot.toString();
		return roots;
	}	

	function type34Generator(u:number):string{
		let [t, x1, y1, x2, y2, sign] = uqnSplit(u);
		const xrSign = sign%4;
		if (xrSign%2==1){
			x2 *= -1;
		}
		if (xrSign>1){
			x1 *= -1;
		}
		if (sign > 3){
			y2 *= -1;
		}
		if (Math.random()<0.5){
			y1 *= -1;
		}
		const root1 = new Complex(x1,y1);
		const root2 = new Complex(x1,-y1);
		let root3: Complex, root4: Complex;
		if (t==3){
			root3 = new Complex(x2,y2);
			root4 = new Complex(x2,-y2);
		} else{
			root3 = new Complex(x2,0);
			root4 = new Complex(y2,0);
		}
		const roots = "z=" + root1.toString() + ", z=" + root2.toString() + ", z=" + root3.toString() + "\\textrm{ or } z=" + root4.toString();
		return roots;
	}	

	function type5Generator(u:number):string{
		let [t, x1, y1, x2, y2, sign] = uqnSplit(u);
		switch (sign){
			case 1:
				y2 *= -1;
				break
			case 2:
				x2 *= -1;
				break
			case 3:
				y1 *= -1;
				break
			case 4:
				x1 *= -1;
				break
			case 5:
				y2 *= -1; y1 *= -1;
				break
			case 6:
				y1 *= -1; x2 *= -1;
				break
			case 7:
				x2 *= -1; x1 *= -1;
				break
			case 8:
				x1 *= -1; y2 *= -1;
				break
			case 9:
				y2 *= -1; x2 *= -1; y1 *= -1;
				break
		}
		const root1 = new Complex(x1,y1);
		const root2 = new Complex(x2,y2);
		const roots = "z=" + root1.toString() + "\\textrm{ or } z=" + root2.toString();
		return roots;
	}	
</script>

<p>
	<Katex math={ans}/>.
</p>
